<br />
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <div class="title-color">
      <h1 class="title">Asignar {{ title }}</h1>
    </div>
    <br />

    <div class="fila-buscador">
      <div class="campo-buscar">
        <app-search-select
          [dataList]="options"
          placeholder="Buscar..."
          [label]="labelSearch"
          noResults="Sin resultados"
          (onSelectOption)="onSelectOption($event)"
        ></app-search-select>
      </div>

      <button class="primary-button" type="button" [disabled]="!itemSelected" (click)="add()">
        <span class="button-content"> <mat-icon fontIcon="add"></mat-icon>Agregar</span>
      </button>
    </div>

    <div class="table-scroll-wrapper">
      <section class="mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table mat-table [dataSource]="items">
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let item">
                <a class="icon-button" matTooltip="Quitar" (click)="eliminar(item)">
                  <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                </a>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ labelItem }}</th>
              <td mat-cell *matCellDef="let item">{{ item.name }}</td>
            </ng-container>

            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef>{{ labelValue }}</th>
              <td mat-cell *matCellDef="let item">
                @if (showValueColumn) {
                  <input
                    class="input-value"
                    type="number"
                    min="0"
                    [value]="item.unitValue"
                    (input)="changeValue(item, $any($event.target).value)"
                  />
                } @else {
                  {{ item.unitValue | currency: money : 'symbol' : '1.0-2' }}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="qty">
              <th mat-header-cell *matHeaderCellDef>Cantidad</th>
              <td mat-cell *matCellDef="let item">
                <div class="control-cantidad">
                  <button
                    mat-icon-button
                    type="button"
                    (click)="decrease(item)"
                    [disabled]="item.qty <= 1"
                  >
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input
                    class="input-cantidad"
                    type="number"
                    min="1"
                    [value]="item.qty"
                    (input)="changeQty(item, $any($event.target).value)"
                  />
                  <button mat-icon-button type="button" (click)="increase(item)">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            @if (showPackage) {
              <ng-container matColumnDef="package">
                <th mat-header-cell *matHeaderCellDef>Paquete</th>
                <td mat-cell *matCellDef="let item">
                  {{ item.package ?? 1 }}
                </td>
              </ng-container>
            }

            @if (showUnity || showUnityColumn) {
              <ng-container matColumnDef="unity">
                <th mat-header-cell *matHeaderCellDef>Unidad</th>
                <td mat-cell *matCellDef="let item">
                  <select
                    class="input-value unity-select"
                    [class.placeholder-shown]="!item.unity"
                    [disabled]="showUnity"
                    (change)="item.unity = $any($event.target).value"
                  >
                    <option value="" disabled [selected]="!item.unity">Seleccione un valor</option>
                    @for (option of unityOptions; track option) {
                      <option [value]="option.value" [selected]="option.value === item.unity">
                        {{ showUnity ? option.value : option.label }}
                      </option>
                    }
                  </select>
                </td>
              </ng-container>
            }

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>Total</th>
              <td mat-cell *matCellDef="let item">
                {{ totalItem(item) | currency: money : 'symbol' : '1.0-2' }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnas"></tr>
            <tr mat-row *matRowDef="let row; columns: columnas"></tr>
          </table>
        </div>
      </section>

      @if (items.length === 0) {
        <p style="text-align: center">Aún no tienes items seleccionados.</p>
      }
    </div>

    <mat-dialog-actions>
      <p>
        Costo total estimado <b>{{ totalGeneral | currency: money : 'symbol' : '1.0-2' }}</b>
      </p></mat-dialog-actions
    >

    <mat-dialog-actions>
      <button class="primary-button" type="submit"  (click)="save()">
        <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
      </button>
      <button class="secondary-button" type="button" (click)="closeDialog()">
        <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
      </button>
    </mat-dialog-actions>
  </div>
</div>
